import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    searchMode: false,
    rootUrl: 'https://wsrdv.openlab.ma/crcapi/'
  },
  mutations: {
    SET_USER_DATA (state, userData) {
      state.user = userData
      localStorage.setItem('user', JSON.stringify(userData))
      axios.defaults.headers.common['Authorization'] = `Bearer ${
          userData.jwt
      }`
    },
    LOGOUT () {
      localStorage.removeItem('user')
      location.reload()
    },
    SET_SEARCH_MODE () {
      this.state.searchMode = !this.state.searchMode
    }
  },
  actions: {
    login ({ commit }, credentials) {
      credentials.action = 'login'

      return axios
          .post(this.state.rootUrl+'apiv1.php', credentials,10000)
          .then(({ data }) => {
            commit('SET_USER_DATA', data.data)
          })
          .catch( error => {
            if(error.response.status == '401'){
              console.log('Oups utilisateur ou mot de passe invalide')
            }

          })
    },
    logout ({ commit }) {
      commit('LOGOUT')
    },
  },
  modules: {
  },
  getters: {
    loggedIn (state) {
      return !!state.user
    }
  }
})
